export default {
  hi_im_neela: 'مرحبًا ، أنا نيلا ، ',
  english: 'English',
  german: 'Deutsch',
  french: 'Français',
  dutch: 'Nederlands',
  swedish: 'Svenska',
  ukrainian: 'Українці',
  turkish: 'Türkçe',
  russian: 'Русский',
  spanish: 'Español',
  italian: 'Italiano',
  arabic: 'عربي',
  polish: 'Polska',
  aareons_virtual: ' مساعد آرون الافتراض',
  media: 'وسائل الإعلام',
  media_link: 'https://neela.aareon.com/media',
  contact: 'اتصال',
  contact_link: 'https://neela.aareon.com/contact',
  privacy: 'سياسة الخصوصية',
  privacy_link: 'https://www.aareon.com/sixcms/detail.php/3627',
  terms_of_use: 'شروط الاستخدام',
  terms_of_use_link: 'https://www.aareon.com/sixcms/detail.php/3621',
  legal_notice: 'إشعار قانوني',
  legal_notice_link: 'https://neela.aareon.com/legal',
  show_system_messages: 'إظهار رسائل النظام',
  dont_show_system_messages: 'إخفاء رسائل النظام',
  logged_in: 'المستأجر مصدق عليه',
  logged_out: 'مستخدم مجهول',
  button_switch_locale: 'تغيير اللغة',
  button_tooltip_activate_voice_recognition: 'قم بتنشيط التعرف على الصوت',
  date_input: 'حدد تاريخ',
  choose_two_dates: 'الرجاء تحديد تاريخين',
  date_range: 'نطاق الموعد',
  from: 'من',
  to: 'ل',
  avatar: 'الصورة الرمزية',
  exit: 'مخرج',
  new: 'جديد',
  back: 'الى الخلف',
  suggestions: 'اقتراحات',
  senton: 'تم الإرسال بتاريخ',
  message_placeholder: 'أدخل الرسالة هنا',
  comment_placeholder: 'أدخل التعليق هنا',
  file_max_upload_text: 'يمكن تحميل 20 ملفًا كحد أقصى',
  message_button_label: 'إرسال',
  please_confirm: 'يرجى تأكيد',
  no: 'رقم',
  yes: 'نعم',
  modal_delete_session: 'حذف الجلسة',
  modal_delete_session_notification:
    'إذا أغلقت النافذة ، فسيتم حذف جلستك أيضًا. <br> هل أنت موافق على ذلك؟',
  template_contact_time: 'متى يمكننا الاتصال بك؟',
  template_pause:
    'تم إيقاف جلستك مؤقتًا. سيهتم أحد موظفي الدعم لدينا بطلبك قريبًا.',
  template_continue_after_pause:
    'استمرت جلستك. يمكنك الآن متابعة الكتابة باستخدام برنامج الدردشة الآلي الخاص بنا.',
  button_apply: 'تطبيق',
  button_cancel: 'يلغي',
  none: 'لا أحد',
  book_appointment: 'موعد الكتاب',
  address_input: 'إدخال العنوان',
  data_processing: 'معالجة البيانات',
  privacy_policy: 'الخصوصية',
  data_processing_notification_before_link:
    'لاستخدام خدمة الدردشة هذه ، من الضروري',
  data_processing_notification_after_link: 'أن تقبل سياسة الخصوصية',
  button_accept: 'قبول',
  select_date: 'حدد تاريخ',
  rate_conversation: 'كيف تقيم هذه المحادثة؟',
  new_ticket_question: 'هل هناك أي شيء آخر يمكنني مساعدتك به؟',
  thank_you: 'شكرا لدعمكم. تساعدني ملاحظاتك على تحسين نفسي باستمرار.',
  goodbye: 'مع السلامة.',
  start_new: 'ابدأ محادثة جديدة',
  operator_entered_the_chat: 'دخل عامل الدردشة',
  operator_left_the_chat: 'غادر عامل الهاتف الدردشة',
  bg_image: process.env.VUE_APP_EN_BG,
  expand_quickreplies: 'أكثر',
  collapse_quickreplies: 'ناقص',
  login: 'تسجيل الدخول',
  logout: 'تسجيل خروج',
  close: 'إغلاق',
  upload_file: ' قم بإسقاط الملفات في أي مكان لتحميلها',
  upload_file_or: ' أو',
  Upload_file_select: ' إضافته',
  upload_file_text: 'قم بإسقاط الملفات للتحميل',
  show_attachments: 'إظهار المرفق',
  hide_attachments: 'إخفاء المرفق',
  maximize: 'تحقيق أقصى قدر',
  minimize: 'تصغير',
  feedback_helpful: 'ساعدني هذا الجواب',
  feedback_not_helpful: 'هذه الإجابة لم تساعدني',
  showMore: 'أظهر المزيد',
  showLess: 'عرض أقل',
  feedbackDescription: 'اقتراحات لنا',
  feedbackSubtitle: {
    description: 'هنا يمكنك أن ترسل إلينا اقتراحات عامة ومقترحات وطلبات.',
    note: 'يرجى ملاحظة أننا لا نستطيع الرد عليهم.',
    hint:
      'يمكن وصف جميع المخاوف الأخرى التي تتعلق على وجه التحديد بإيجارك أو البحث عن شقة لنا في الدردشة.'
  },
  feedbackPlaceholder: 'أدخل الرسالة هنا...',
  sendFeedback: 'يرسل',
  giveFeedback: 'اقتراحات لنا',
  feedbackSubmittedSuccessfully: 'تم إرسال ملاحظاتك بنجاح',
  thanks: 'شكرًا'
}
